function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.5 -1.5)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M27.684,23.547a2.568,2.568,0,0,1-2.568,2.568H4.568A2.568,2.568,0,0,1,2,23.547V5.568A2.568,2.568,0,0,1,4.568,3H10.99l2.568,3.853H25.116a2.568,2.568,0,0,1,2.568,2.568Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("line", {
  className: "a",
  y2: 8,
  transform: "translate(15 13)"
}), /*#__PURE__*/React.createElement("line", {
  className: "a",
  x2: 8,
  transform: "translate(11 17)"
}));

function SvgAddProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.684,
    height: 26.116,
    viewBox: "0 0 28.684 26.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProject);
export default __webpack_public_path__ + "static/media/add_project.2f1cffe1.svg";
export { ForwardRef as ReactComponent };